var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCustomLog = function SvgIconCustomLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1810_4228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1202 4.30495C19.9684 4.15318 19.7408 4.07729 19.4372 4.07729C19.1336 4.15318 11.0135 5.51918 7.67436 8.85831C5.32179 11.2109 5.17001 13.7911 5.54945 15.6125L8.35736 13.9429C8.73681 13.7152 9.11625 14.2465 8.8127 14.55L6.00479 17.3579L3.87989 19.4828C3.57633 19.7864 3.57633 20.2417 3.87989 20.5453C4.03167 20.697 4.18345 20.7729 4.41111 20.7729C4.63878 20.7729 4.79056 20.697 4.94234 20.5453L7.06724 18.4204C7.67436 18.7239 8.8127 19.1034 10.2546 19.1034C11.9242 19.1034 13.4419 18.5721 14.808 17.5097C15.0356 17.3579 15.1874 16.9785 15.0356 16.6749L13.9732 12.8804L16.7052 13.9429C17.0846 14.0947 17.54 13.9429 17.6917 13.5635C19.2854 9.99665 20.272 5.21563 20.3479 5.06385C20.3479 4.76029 20.272 4.45673 20.1202 4.30495Z",
    fill: "#249DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1810_4228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgIconCustomLog as ReactComponent };
export default __webpack_public_path__ + "icon-custom-log.svg";